import * as React from 'react'
import styles from './style.module.css';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Schedule from '../../Schedule';
import { useLocalServices } from '../../../../../../../hooks';
import { Edit_Travel_Operate_Changed, Edit_Travel_set_Dropoff_inputs, Edit_Travel_set_pickup, Set_Pickup_Inputs } from '../../../../../../../Redux/actions/actionNames';
import { CLOSE } from '../../../../../../../assets';
import Typography from '../../../../../../../design-system/lib/Typography';
import Input from '../../../../../../../design-system/lib/Input';
import Button from '../../../../../../../design-system/lib/Button';

import PhoneInput from '@onro/react-phone-input-2'
import '@onro/react-phone-input-2/lib/style.css'

import Address_details_Icon from '../../../../../../../assets/IconProvider/address_details_color.svg'
import ArrowDown from '../../../../../../../assets/IconProvider/Arrow---Down-2.svg'
import address_details from '../../../../../../../assets/IconProvider/address_details.svg'
import email_x from '../../../../../../../assets/IconProvider/email_x.svg'
import notes_X from '../../../../../../../assets/IconProvider/notes_X.svg'
import person_x from '../../../../../../../assets/IconProvider/person_x.svg'
import IconProvider from '../../../../../../../design-system/lib/IconProvider';

function DropoffInfoEditOrder({ handleShowInfo, addressDetail, floor, room, email, fullName, phone, customerDescription, scheduleDateBefore, scheduleDateAfter, buildingBlock, id, first, pickupRequiredCheck }) {
  const serviceId = useSelector((state) => state.ViewTravel.pureData.service.id)
  const serviceactiveVehicleType = useSelector((state) => state.EditOrder.editOrder.service.activeVehicleType)
  const deliveryMethodSetting = useSelector((state) => state.ViewTravel.pureData.deliveryMethod?.setting)

  const [phoneval, setPhoneval] = React.useState((phone && phone.length > 0) ? (String(phone).startsWith("+") ? phone : (String(phone).startsWith("00") ? "+" + String(phone).slice(2, phone) : "")) : "");
  const deliveryMethod = useSelector((state) => state.ViewTravel.pureData?.deliveryMethod)


  const unit = room;
  const senderFullName = fullName;
  const senderPhoneNumber = phone;
  const ActivescheduleSetting = useSelector((state) => state.ViewTravel.pureData?.deliveryMethod?.scheduleSetting?.isActive)
  const orderTypeActive = useSelector((state) => state.ViewTravel.pureData.type)
  const block = buildingBlock;

  const CustomerDescription = customerDescription
  const { t, i18n } = useTranslation();
  const [collapsed, setCollapsed] = React.useState(true);


  const dispatch = useDispatch();


  const closeDialoge = () => {
    handleShowInfo()
  };


  const Emailvalidate = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }


  const handlePickUpInputs = (e, name) => {
    dispatch(Edit_Travel_Operate_Changed());


    dispatch(
      Edit_Travel_set_Dropoff_inputs({
        name: name,
        value: e.target.value ? e.target.value : "",
        firstDropOff: first,
        id: id,
      })
    );




  };


  const phoneNumberOnChange = React.useCallback((res, ddd) => {
    console.log("phoneNumberOnChange ", res, ddd)

    setPhoneval(res)

    dispatch(
      Edit_Travel_set_Dropoff_inputs({
        name: ddd,
        value: res,
        firstDropOff: first,
        id: id,
      })
    );

    dispatch(Edit_Travel_Operate_Changed());

  }, [first, id]);

  const detectOrderType = React.useCallback(() => {

    if (serviceactiveVehicleType && serviceactiveVehicleType.orderTypes?.indexOf("PickupDelivery") > -1) {
      return "PickupDelivery"
    } else {
      return "Ondemand"
    }

  }, [serviceactiveVehicleType])

  const GetDetailsInputtoText = React.useCallback(() => {

    let xxx = ""

    if (addressDetail && String(addressDetail).trim().length > 0 && (serviceactiveVehicleType?.setting?.isAddressDetailsActive && detectOrderType() == "PickupDelivery")) {
      String(xxx).length > 0 ? xxx += `, ${addressDetail}` : xxx += `${addressDetail}`;
    }

    if (block && String(block).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${block}` : xxx += `${block}`
    }

    if (floor && String(floor).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${floor}` : xxx += `${floor}`
    }

    if (unit && String(unit).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${unit}` : xxx += `${unit}`
    }

    if (email && String(email).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${email}` : xxx += `${email}`
    }


    if (senderFullName && String(senderFullName).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${senderFullName}` : xxx += `${senderFullName}`
    }


    if (senderPhoneNumber && String(senderPhoneNumber).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${senderPhoneNumber}` : xxx += `${senderPhoneNumber}`
    }



    if (customerDescription && String(customerDescription).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${customerDescription}` : xxx += `${customerDescription}`
    }

    return xxx

  }, [addressDetail, block, floor, unit, email, senderFullName, senderPhoneNumber, customerDescription, serviceactiveVehicleType])



  return (
    <div className={styles.NewCustomerRegisterContainer} >
      <div className={styles.collapseHeaderContainer} onClick={() => { setCollapsed(!collapsed) }}>

        <IconProvider Icon={Address_details_Icon} size='14' style={{ marginInlineStart: "11.6px" }} />
        <Typography text={<>{t("Details")}{(String(GetDetailsInputtoText()).length > 0 && !collapsed) ? ":" : ""} {!pickupRequiredCheck && <span className={styles.starRequired} style={{ color: "red" }}>*</span>} </>} weight="Body_Middle_Medium" style={{ marginInlineStart: "4px" }} />
        {!collapsed && <Typography text={GetDetailsInputtoText()} weight="Body_Tiny_Regular" style={{ marginInlineStart: "4px", textDecoration: 'none', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', width: 'auto', flex: '1' }} />}


        <IconProvider Icon={ArrowDown} size='10' style={{ marginInlineStart: "auto", marginInlineEnd: "10px", transform: collapsed ? "" : "rotate(180deg)" }} />
      </div>

      {(!collapsed && !pickupRequiredCheck) && <Typography text={t("CompleteRequiredFeileds")} weight='Body_Small_Regular' style={{
        width: "345px", overflow: 'hidden', marginTop: "6px",
        textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1"
      }} textColor='Red' />}

      {collapsed && <div className={styles.body}>

        <div className={styles.inputsConatiner}>
          {(deliveryMethodSetting.isDropoffAddressRoomFloorBlockActive && orderTypeActive != "PickupDelivery") && <div className={styles.threeCOLUMNS}>
            <Input type={"text"} placeHolder={t("block")} value={block} inputStyle={{ width: "inherit" }} onChange={(e) => { handlePickUpInputs(e, "buildingBlock") }} />
            <Input type={"text"} placeHolder={t("Floor")} value={floor} inputStyle={{ width: "inherit" }} onChange={(e) => { handlePickUpInputs(e, "floor") }} />
            <Input type={"text"} placeHolder={t("Unit")} value={unit} inputStyle={{ width: "inherit" }} onChange={(e) => { handlePickUpInputs(e, "room") }} />
          </div>}

          {(deliveryMethodSetting.isAddressDetailsActive && orderTypeActive == "PickupDelivery") &&
            <Input  iconStart={address_details}  type={"text"} placeHolder={t("addressDetail")} value={addressDetail} inputStyle={{ width: "inherit" }} onChange={(e) => { handlePickUpInputs(e, "addressDetail") }} />
          }
        {(deliveryMethodSetting?.isDropoffAddressNameActive || deliveryMethodSetting?.isDropoffAddressEmailActive) && <div className={styles.twoColumnContainer}>

          {deliveryMethodSetting.isDropoffAddressNameActive && <Input  iconStart={person_x} isRequired={deliveryMethodSetting.isDropoffAddressNameRequired} isRequiredText={t("*")} type={"text"} placeHolder={t("Fullname")} value={senderFullName} onChange={(e) => { handlePickUpInputs(e, "fullName") }} />}

          {(deliveryMethodSetting.isDropoffAddressEmailActive) && <Input iconStart={email_x}  isRequired={deliveryMethodSetting.isDropoffAddressEmailRequired} isRequiredText={t("*")} error={Emailvalidate(email) ? "" : t("Emailisnotcorrect")} type={"text"} value={email} placeHolder={t("email")} onChange={(e) => { handlePickUpInputs(e, "email") }} />}


    

         
         </div>}

               {deliveryMethodSetting.isDropoffAddressPhoneActive &&


            <div className={styles.PhoneInput}>


              <PhoneInput
                countryCodeEditable={false}
                country={String(global.config.countryCca2).toLowerCase()}
                className={clsx(styles.inputContainer, "newUi_senderphonenumberPickup")}
                value={phoneval}
                onChange={(e1, e2, e3, e4) => { phoneNumberOnChange(e4, "phone") }}
                enableLongNumbers={true}
                inputProps={{ type: "text" }}
                copyNumbersOnly={false}
                autoFormat={false}
                placeHolder={t("Phonenumber")}

              />

              {deliveryMethod &&
                deliveryMethod.setting &&
                deliveryMethod.setting.isDropoffAddressPhoneRequired && (senderPhoneNumber ? String(senderPhoneNumber).trim().length == 0 : true) && (
                  <span className={`inputRequired ${styles.PhoneInputRequired}`}>
                    {t("*")}
                  </span>
                )}
            </div>

          }

          {orderTypeActive != "PickupDelivery" && <Input iconStart={notes_X} type={"text"} value={CustomerDescription} placeHolder={t("notesfordriver")} onChange={(e) => { handlePickUpInputs(e, "customerDescription") }} />}



        </div>

      </div>}



    </div>
  )
}

export default DropoffInfoEditOrder